import React from 'react';
import { Tag } from './ui/Tag';
import { faqs } from '../data/landing';
export function FaqSection() {
  return <section className="w-full bg-[#f8fafc] py-20 sm:py-28" aria-labelledby="faq-title" data-id="element-29" data-mp="1pkjvlxmu91sl">
      <div className="mx-auto w-full max-w-5xl px-6" data-id="element-30" data-mp="1blai55q0olsb">
        <div className="mx-auto max-w-2xl text-center" data-id="element-31" data-mp="1bmlnvb30w3m2">
          <Tag data-id="element-32" data-mp="1gkn29ipi7er7">Preguntas Frecuentes</Tag>
          <h2 id="faq-title" className="mt-6 font-serif text-3xl font-bold leading-tight text-[#0f172a] sm:text-4xl lg:text-5xl" data-id="element-33" data-mp="1glpvvye7nvat">
            Respuestas Directas
          </h2>
        </div>

        <dl className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-34" data-mp="28a0354wxxuii">
          {faqs.map(faq => <div key={faq.question} className="rounded border border-slate-200 bg-white p-7" data-id="element-35" data-mp="1uili6sjh3j8t">
              <dt className="font-serif text-lg font-bold leading-snug text-[#0f172a]" data-id="element-36" data-mp="1zh6i0qutc0wq">
                {faq.question}
              </dt>
              <dd className="mt-3 text-sm leading-relaxed text-slate-600" data-id="element-37" data-mp="2n5z8w8wkvikh">
                {faq.answer}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}